var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.66 88.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272763;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#c57cfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.92,79.2h34.66c1.52,0,2.98.6,4.07,1.67l7.16,7.06c.77.76,2.07.21,2.07-.87v-46.97c0-3.27-2.65-5.92-5.92-5.92H5.92c-3.27,0-5.92,2.65-5.92,5.92v33.18c0,3.27,2.65,5.92,5.92,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.73,52.34h-34.66c-1.52,0-2.98.6-4.07,1.67l-7.16,7.06c-.77.76-2.07.21-2.07-.87V13.23c0-3.27,2.65-5.92,5.92-5.92h42.04c3.27,0,5.92,2.65,5.92,5.92v33.18c0,3.27-2.65,5.92-5.92,5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.89,55.12c-.22,0-.45-.04-.67-.14-.65-.27-1.05-.88-1.05-1.58V6.42c0-3.54,2.88-6.42,6.42-6.42h42.04c3.54,0,6.42,2.88,6.42,6.42v33.18c0,3.54-2.88,6.42-6.42,6.42h-34.67c-1.4,0-2.72.54-3.72,1.52l-7.16,7.06c-.33.33-.76.5-1.2.5ZM45.58,1c-2.99,0-5.42,2.43-5.42,5.42v46.97c0,.3.17.55.44.66.28.11.57.06.78-.15l7.16-7.06c1.19-1.17,2.75-1.81,4.42-1.81h34.67c2.99,0,5.42-2.43,5.42-5.42V6.42c0-2.99-2.43-5.42-5.42-5.42h-42.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.29,82.58c-.44,0-.86-.17-1.2-.5l-7.16-7.06c-1-.98-2.32-1.52-3.72-1.52H9.56c-3.54,0-6.42-2.88-6.42-6.42v-33.18c0-3.54,2.88-6.42,6.42-6.42h30.1c.28,0,.5.22.5.5s-.22.5-.5.5H9.56c-2.99,0-5.42,2.43-5.42,5.42v33.18c0,2.99,2.43,5.42,5.42,5.42h34.66c1.67,0,3.23.64,4.42,1.81l7.16,7.06c.21.21.51.26.78.15.28-.12.44-.36.44-.66v-26.02c0-.28.22-.5.5-.5s.5.22.5.5v26.02c0,.71-.4,1.31-1.05,1.58-.22.09-.45.14-.67.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.53,28.9c-.28,0-.5-.22-.5-.5v-.22c0-2.02,1.12-3.94,3-5.13,1.66-1.05,2.48-3,2.07-4.96-.37-1.76-1.79-3.19-3.55-3.55-1.42-.29-2.86.05-3.95.94-1.1.89-1.73,2.21-1.73,3.62,0,.28-.22.5-.5.5s-.5-.22-.5-.5c0-1.71.76-3.32,2.09-4.4,1.33-1.08,3.08-1.5,4.79-1.14,2.14.45,3.88,2.19,4.33,4.33.49,2.37-.49,4.73-2.51,6-1.58,1-2.53,2.61-2.53,4.29v.22c0,.28-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.53,35.2c-.57,0-1.04-.46-1.04-1.04s.46-1.04,1.04-1.04,1.04.46,1.04,1.04-.46,1.04-1.04,1.04ZM66.49,34.16s.02.04.04.04l-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.56,51.28c-.57,0-1.04-.46-1.04-1.04s.46-1.04,1.04-1.04,1.04.46,1.04,1.04-.46,1.04-1.04,1.04ZM18.52,50.24s.02.04.04.04l-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.94,51.28c-.57,0-1.04-.46-1.04-1.04s.46-1.04,1.04-1.04,1.04.46,1.04,1.04-.46,1.04-1.04,1.04ZM26.91,50.24s.02.04.04.04l-.04-.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponde);
export default __webpack_public_path__ + "static/media/responde.af566608e857f2aec87bce98d124b574.svg";
export { ForwardRef as ReactComponent };